import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-black mt-24">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-6">
            <span className="inline-block w-2.5 h-2.5 bg-lime" />
            <span className="font-heading text-2xl font-black tracking-tighter">PITCH<span className="text-lime">.</span>LU</span>
          </div>
          <p className="text-white/60 text-sm max-w-md leading-relaxed">
            Unedited. €20,000 on the table. Founders pitch, get grilled, and walk away with a real
            investment decision — on LinkedIn.
          </p>
        </div>
        <div>
          <div className="text-xs font-mono uppercase tracking-widest text-white/40 mb-4">Explore</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/episodes" className="text-white/80 hover:text-lime">Episode Library</Link></li>
            <li><Link to="/apply" className="text-white/80 hover:text-lime">Apply to Pitch</Link></li>
            <li><Link to="/#how" className="text-white/80 hover:text-lime">How it Works</Link></li>
            <li><Link to="/#faq" className="text-white/80 hover:text-lime">FAQ</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs font-mono uppercase tracking-widest text-white/40 mb-4">Contact</div>
          <ul className="space-y-3 text-sm text-white/80">
            <li>
              <a
                href="https://www.linkedin.com/in/simonelatorre/"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-linkedin-link"
                className="hover:text-lime break-all"
              >
                linkedin.com/in/simonelatorre
              </a>
            </li>
            <li>
              <Link to="/admin/login" data-testid="footer-admin-link" className="text-white/40 hover:text-lime text-xs">
                Host login →
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 px-6 md:px-10 text-xs font-mono text-white/40 flex justify-between max-w-[1440px] mx-auto">
        <span>© {new Date().getFullYear()} PITCH.LU</span>
        <a
          href="https://www.kiitos.lu"
          target="_blank"
          rel="noreferrer"
          data-testid="footer-kiitos-link"
          className="hover:text-lime transition-colors"
        >
          An initiative by Kiitos.lu
        </a>
      </div>
    </footer>
  );
}
